module.exports = __webpack_public_path__ + "static/media/Health-based-Level01.ba936d81.svg";